// Barcode scanners type the value then press Enter — treat Enter as "next field" instead of submit.
const FIELD_SELECTOR = 'input:not([type=hidden]):not([disabled]):not([readonly]), textarea:not([disabled]), select:not([disabled]), [role="combobox"]:not([disabled])';

export const advanceOnEnter = (e) => {
  if (e.key !== 'Enter' || e.defaultPrevented || e.nativeEvent?.isComposing) return;
  const el = e.target;
  if (el.tagName !== 'INPUT' || ['submit', 'button', 'checkbox', 'radio'].includes(el.type)) return;
  e.preventDefault();
  const scope = el.closest('form') || document;
  const fields = Array.from(scope.querySelectorAll(FIELD_SELECTOR)).filter((f) => f.offsetParent !== null);
  const next = fields[fields.indexOf(el) + 1];
  if (next) next.focus();
};
